import React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { FeaturedCategoryTiles, FounderTales, Icon, MetaData, QuestionForm } from '../../../../components'
import DiscoverFeed from '../../../../services/algorithms/DiscoverFeed'

import { 
	getArticlesFeed, 
	refreshArticlesFeed, 
	toggleArticleFlare 
} from '../../../../actions/articles'
import { toggleArticleBookmark } from '../../../../actions/article'

import { 
	FeaturedLatest,
	Latest,
	InterestCluster as InterestArticles,
	FeaturedHorizontal,
	FeaturedVertical as VerticalFeatured,
	FeaturedLatestLoading as LoadingFeatured,
	LatestLoading as LoadingLatest
} from './components'

import Interests from '~/components/Interests/Add'

class Unfiltered extends React.Component {
    constructor(props) {
    	super(props);

    	const articles = props.discoverFeed;

    	let featuredLinks = articles.latest.slice(0, 4);

    	if(featuredLinks.length) {
            featuredLinks.push(newsletterItem);
        }

    	this.state = {
            articles,
            isQueuedForRefresh: false,
            featuredLinks
        };
	}

    refreshBarTop = '-100px';

    componentDidMount() {
    	if(!this.props.articles.all.length) {
    		this.props.getArticlesFeed();
		} else {
            this.props.refreshArticlesFeed()
		}
	}

    componentDidUpdate(prevProps, prevState) {

		// Check if this is from a new interest added or removed and disallow
		let nextProps 		= this.props,
			nextState 		= this.state;

		let prevInterests 	= prevProps.session.interests,
			nextInterests 	= nextProps.session.interests;

		let isModalChild 		= prevProps.isModalChild,
			isQueuedForRefresh 	= prevState.isQueuedForRefresh,
			alreadyHasArticles 	= prevState.articles.latest.length > 0,
			willBeArticles 		= nextState.articles.latest.length > 0,
			articlesFetchedYet 	= nextProps.articles.all.length > 0,
			workshopsFetchedYet = nextProps.workshops.all.length > 0,
			interestsFetchedYet = !nextProps.session.fetching.interests;

        if(this.state.articles.latest.length && this.state.featuredLinks.length <= 1) {
		    let featuredLinks = this.state.articles.latest.slice(0, 4);

            featuredLinks.push(newsletterItem);

		    this.setState({ featuredLinks });
        }

		if( !articlesFetchedYet ) return false;
		if( !workshopsFetchedYet ) return false;
		if( !interestsFetchedYet ) return false;

		if( alreadyHasArticles ) return false;
		if( alreadyHasArticles && isModalChild ) return false;
		if( willBeArticles && !isQueuedForRefresh ) return false;

		console.log('getting new articles')

		this.setState({
			articles: DiscoverFeed.get(
				nextProps.articles.all,
				nextProps.workshops.all,
				'interests' in nextProps.session ? nextProps.session.interests : [],
				this.props.session.sessionsAllowed
			),
			isQueuedForRefresh: false
		});

	}

    bookmark = (article_id) => {
		this.props.toggleArticleBookmark(article_id)
	};

    flare = (article_id) => {
		this.props.toggleArticleFlare(article_id)
	};

    divider = (text) => {
		return <div className="articles-divider clearfix">
        	<hr />
        	{ text > "" && <p>{text}</p> }
    	</div>
	};

    showRefreshBar = () => {
		this.refreshBarTop = '0px';
	};

    refreshFeed = () => {
		this.refreshBarTop = '-100px';
		this.setState({
			isQueuedForRefresh: true
		})
		this.props.getArticlesFeed()
	};

    render() {

		let fetching = this.props.articles.fetching;

		let { featuredLinks, articles: { interestGroup, ofTheWeek, featured, missed, latest, interests } } = this.state;

		let isSession = 'ID' in this.props.session.user;

		console.log(ofTheWeek, featured)

		return (
			<div>

				<MetaData page="articles" />

                { this.props.session.sessionsAllowed &&
					<div className="refresh-feed clickable" style={{top: this.refreshBarTop}} onClick={this.refreshFeed}>
						<p>Refresh your feed <Icon icon="refresh" className="mleft10"/></p>
					</div>
                }

				<div className="row full-height">
		            <div className="col-sm-7 match-height pbot50-xs">
			            { fetching
							? <LoadingFeatured />
	            			: !!featured && featured.length > 0 &&
	            				<FeaturedLatest {...featured[0]}
	            					bookmark={isSession ? this.bookmark : false}
	            					flare={isSession ? this.flare : false} />
        				}
	            	</div>
		            <div className="col-sm-5">
            			{ fetching
							? <LoadingLatest />
	            			: !!featured && featuredLinks.length > 0 && <Latest articles={featuredLinks} />
	            		}
	            	</div>
            	</div>

                {/*{ !fetching && this.divider() }*/}

                {/*<QuestionForm />*/}

            	{ !fetching && this.divider() }

            	<FounderTales />

            	{ !fetching && this.divider() }

                <FeaturedCategoryTiles />

            	{ !fetching && this.divider() }

				{ !fetching &&
					<div className="row full-height">
			            <div className="col-lg-5 col-md-7 col-sm-6 col-xs-12 mbot50-xs">
			            	{ !!interestGroup && interestGroup.length > 0 && interestGroup[0].posts.length >= 4 && ('posts' in interestGroup[0]) &&
			            		<InterestArticles articles={interestGroup[0].posts} interest={interestGroup[0].interest} />
			            	}
		            	</div>
			            <div className="col-lg-7 col-md-5 col-sm-6 col-xs-12 match-height">
							{ ( (!!ofTheWeek && 'ID' in ofTheWeek) || (!!featured && featured.length >= 3) ) &&
			            		<VerticalFeatured {...( 'ID' in ofTheWeek ? ofTheWeek : featured[2]) }
			            			sectionTitle={ 'ID' in ofTheWeek ? "Your Article of The Week" : "" }
			            			bookmark={isSession ? this.bookmark : false}
			            			flare={isSession ? this.flare : false} />
		            		}
		            	</div>
	            	</div>
	            }

            	{ !!featured && featured.length >= 2 && !fetching &&
					<div>
		            	{this.divider()}
						<FeaturedHorizontal {...featured[1]}
							history={this.props.history}
							bookmark={isSession ? this.bookmark : false}
							flare={isSession ? this.flare : false} />
        			</div>
        		}

            	{ this.props.session.sessionsAllowed && !!this.props.session.interests && !fetching && interests.length > 0 &&
					<React.Fragment>
		            	{this.divider( 'ID' in this.props.session.user ? 'Recommended Interests' : '' )}
		            	{!('ID' in this.props.session.user)
		            		? <div>
		            			<p className="text-center text-mid-gray mbot40">Achieve your growth goals by getting the right content for you</p>
		            			<p className="text-center"><Link to="/register" className="btn btn-primary">Sign Up</Link></p>
	            			</div>
	            			: <Interests  dispatch={this.props.dispatch}
									userInterests={this.props.session.interests}
									interests={interests}
									changeInterest={this.showRefreshBar}
									overrideLink={'ID' in this.props.session.user ? false : '/register?error=register_for_interests'}
									message={'Add these interests to your profile to focus the content you see'}
									history={'ID' in this.props.session.user ? false : this.props.history} />
						}
        			</React.Fragment>
        		}

            	{ !fetching && this.divider() }

				{ !fetching &&
					<div className="row full-height">
			            <div className="col-lg-7 col-md-5 col-sm-6 col-xs-12 match-height mbot50-xs">
			            	{ !!missed && 'ID' in missed &&
			            		<VerticalFeatured {...missed}
			            			sectionTitle="Did you miss..."
			            			bookmark={isSession ? this.bookmark : false}
			            			flare={isSession ? this.flare : false}
			            			history={this.props.history} />
		            		}
		            	</div>
			            <div className="col-lg-5 col-md-7 col-sm-6 col-xs-12 mbot50-xs">
			            	{ !!interestGroup && interestGroup.length > 1 && interestGroup[1].posts.length >= 4 && ('posts' in interestGroup[1]) &&
			            		<InterestArticles articles={interestGroup[1].posts} interest={interestGroup[1].interest} />
			            	}
		            	</div>
	            	</div>
	            }

            	{ !!featured && featured.length >= 3 && !fetching &&
					<div>
		            	{this.divider()}
						<FeaturedHorizontal {...featured[2]}
							history={this.props.history}
							bookmark={isSession ? this.bookmark : false}
							flare={isSession ? this.flare : false} />
        			</div>
        		}

			</div>
		)
		
	}
}

const newsletterItem = {
    id: 'newsletter',
    link: '/sign-up',
    title: 'Sign up for the newsletter to be the first to hear new stories',
    images: {
        square: '/img/mail-tile.svg'
    }
}

const mapStateToProps = state => ({
    articles: state.articles,
    session: state.session,
	workshops: state.workshops,
	discoverFeed: state.discoverFeed
});

const mapDispatchToProps = dispatch => bindActionCreators({ getArticlesFeed, refreshArticlesFeed, toggleArticleBookmark, toggleArticleFlare }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( Unfiltered );



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/index.jsx